import {
  actions,
  getDailyActiveUsersCountAsync,
  getMonthlyActiveUsersAsync,
  getWeeklyActiveUsersAsync,
  getUserActiveRetentionAfterFirstSessionAsync,
  getActiveUserCountAsync,
  getActiveUsersHourlyBreakdownAsync,
  getContentTypeCountAsync,
  getMinutesListendTodayAsync,
  getMostRatedContentAsync,
  getTopContentAsync,
  getuserDetailedRetuntionAfterRegistrationAsync,
} from './slices';

export const ContentAnalysisActions = {
  ...actions,
  getDailyActiveUsersCountAsync,
  getMonthlyActiveUsersAsync,
  getWeeklyActiveUsersAsync,
  getUserActiveRetentionAfterFirstSessionAsync,
  getActiveUserCountAsync,
  getActiveUsersHourlyBreakdownAsync,
  getContentTypeCountAsync,
  getMinutesListendTodayAsync,
  getMostRatedContentAsync,
  getTopContentAsync,
  getuserDetailedRetuntionAfterRegistrationAsync,
};
